var ApplicationsAPI = require("../../../../common/api/application");
var PortalAPI = require("../../../../common/api/portal");
var PaymentGatewayApi = require("../../../../common/api/paymentGateway");
var UserAPI = require('../../../../common/api/user');
var DonationAPI = require('../../../../common/api/donation');
var _ = require("underscore");

module.exports = function DonorJourneyController($scope, $state, $stateParams, $location, $rootScope, gRecaptcha) {
    var vm = $scope;

    vm.donorNameDisabled = false;
    vm.donorNamePlaceHolder = "";
    vm.donorAliasNameBak = "";

    vm.maxChars = 300;
    vm.page = 1;

    vm.paymentAttempted = false;

    vm.BACS_error = null;
    vm.BACS_attempted = false;
    vm.BACS_registered = false;

    vm.forgotPassword = {
        display: false,
        error: null,
        success: null
    };
    vm.postDonation = {
        shareDetails: false
    };
    vm.application = {
        id: null,
        organisationName: 'This organisation',
        projectTitle: "Test project",
        projectDescription: "",
        coverPictureUrl: null,
        applicantCoverPictureUrl: null,
        userRef: 12345,
        fundings: [ ]
    };
    vm.questions = [];
    vm.fundingList = [{
        funderName: 'asdlfk',
        amount: 200
    }];
    vm.fundraiserId = $scope.ngDialogData.fundraiserId;
    vm.predefinedAmount = true;
	vm.gRecaptcha = gRecaptcha;

    vm.$watch('donation.donationAmount', function (newVal, oldVal) {
        vm.predefinedAmount = false;
        updateFundingList(false);
    });

    vm.$watch('donation.otherAmount', function (newVal, oldVal) {
        vm.predefinedAmount = newVal == null;
        if (!vm.predefinedAmount) {
            vm.donation.donationAmount = vm.donation.otherAmount;
        }
    });

    function updateFundingList(includeGiftAid) {
        vm.fundingList.length = 0;
        var runningTotal = vm.donation.donationAmount;
        if (includeGiftAid){
            runningTotal +=  vm.getGiftAidAmount();
        }

        angular.forEach(vm.application.fundings, function (funding) {
            var amount = (funding.ratioDonate * vm.donation.donationAmount) / funding.ratioMatch;

            if ((funding.maxDonation != null) && (amount > funding.maxDonation)) {
                amount = funding.maxDonation;
            }
            if ((funding.maxCombinedDonation != null) && (amount > funding.maxCombinedDonation - runningTotal)){
                amount = funding.maxCombinedDonation - runningTotal;
            }

            if (amount > 0) {
                amount = roundToPence(amount);
                vm.fundingList.push({ 
                    funderName: funding.funderName, 
                    amount,
                    ratioDonate: funding.ratioDonate,
                    ratioMatch: funding.ratioMatch,
                    maxDonation: funding.maxDonation
                 });
                 runningTotal = roundToPence(runningTotal + amount);
            }
        });
    }

    vm.giftAidRate = 0.25;
    vm.loginDetails = {
        email: '',
        password: '',
        name: '',
        loggedIn: false,
        loggedInOnLoad: false,
        newUser: false
    };
    vm.registerDetails = {
        email: '',
        firstName: '',
        lastName: '',
        password: '',
        termsAndConditions: false,
        answers: [],
        registerError: null
    };
    vm.displayRegister = false;

    vm.billing = {
        address1: '',
        address2: '',
        townCity: '',
        county: '',
        postcode: ''
    };
    vm.donor = {
        address1: '',
        address2: '',
        townCity: '',
        county: '',
        postcode: '',
        isDonorAddressDifferent: false
    };

    if ($rootScope.auth && $rootScope.auth.email) {
        vm.loginDetails.loggedIn = true;
        vm.loginDetails.loggedInOnLoad = true;
        vm.loginDetails.email = $rootScope.auth.email;
        vm.loginDetails.name = getFullName($rootScope.auth.first_name, $rootScope.auth.last_name);
    }

    vm.donation = {
        donorType: -1,
        giftAid: true,
        giftAidConfirm: false,
        donorAliasName: '',
        donationAmount: 30,
        otherAmount: null,
        email: '',
        donorMessage: '',
        isAnonymous: false,

        charityName: "",
        companyName: "",
        isCompanyBenefit: false,
        companyBenefits: "",
        paymentTypeBacs: false,

        feeAmount: 0
    };

    vm.paymentcard = {
        name: "",
        number: "",
        expiryMonth: "",
        expiryYear: "",
        cvv: "",
    };

    // Handlers
    vm.close = function (viewDonation) {
        vm.closeThisDialog({ action: "close", viewDonation: viewDonation });
    };
    vm.cancel = function () {
        vm.closeThisDialog({ action: "cancel" });
    };



    // UI activated functions
    vm.setDisplayRegister = function (setDisplayRegister) {
        vm.displayRegister = setDisplayRegister;
        setTimeout(function(){
            // Scroll to bottom of dialog.
            var page = document.querySelector("#donationForm");
            page.scrollTo({top: 1000});
        }, 100);
    };

    vm.setAmount = function (newAmount) {
        vm.donation.otherAmount = null;
        vm.donation.donationAmount = newAmount;
    };

    vm.setPage = function (newPage) {
        vm.clearP1Errors();

        if (vm.page === 1 && newPage === 2 && !vm.donation.donorAliasName) {
            vm.donation.donorAliasName = getDonorName();
            vm.donation.email = getDonorEmail();
        }

        if (newPage === 3) {
            vm.paymentcard.name = getDonorName();

            setTimeout(function () {
                angular.forEach(vm.donationForm.$error.required, function (field) {
                    field.$setTouched();
                });
            }, 100);
        };

        vm.page = newPage;
        setTimeout(function () {
            var page = document.querySelector("#donationForm");
            page.scrollTo({top: 0});
        }, 100);
    };

    vm.setPaymentTypeBacs = function (value) {
        vm.donation.paymentTypeBacs = value;
    };

    function getFullName(firstName, lastName) {
        return firstName + lastName ? firstName + ' ' + lastName : '';
    }
    function getDonorName() {
        return vm.loginDetails.name;
    }
    function getDonorEmail() {
        return vm.loginDetails.email;
    }

    vm.getTotalAmount = function(incGiftAid, incFunding) {
        let total = Number(vm.donation.donationAmount);
        if (incFunding) {
            angular.forEach(vm.fundingList, function (funding) {
                total += funding.amount;
            });
        }

        if (incGiftAid) {
            total += vm.getGiftAidAmount();
        }
        
        return roundToPence(total);
    };


    vm.getGiftAidAmount = function () {
        return vm.hasGiftAid() ? roundToPence(vm.donation.donationAmount * vm.giftAidRate) : 0;
    };

    vm.formatCurrency = function (amount, simplified) {
        if (!amount) amount = 0;
        amount = Number(amount);

        let result = 0;
        if (simplified && isInt(amount)) {
            result = amount.toFixed(0);
        }
        else {
            result = amount.toFixed(2);
        }

        return "\u00A3" + result;
    };

    function isInt(value){
        if (isNaN(value)) {
            return false;
        }
        var x = parseFloat(value);
        return (x | 0) === x;
    };

    vm.checkPageTwoValid = function (a) {
        // Check that donorType is defined & that if personal and they are offering GA, that they have confirmed
        return vm.donation.donorType !== -1 && 
            ((vm.donation.donorType !== 0) || !vm.donation.giftAid || vm.donation.giftAidConfirm);
    };

    vm.checkPageThreeValid = function () {
        return vm.donationForm.$valid && (vm.donation.paymentTypeBacs || vm.checkCardType(true)) ;
    };

    vm.$watch('donation.donorMessage', function (newVal, oldVal) {
        if (!newVal)
            return;
        if (newVal.length > vm.donation.maxChars) {
            vm.donation.donorMessage = vm.donation.donorMessage.substring(0, vm.donation.maxChars);
        }
    });

    vm.$watch('donation.isAnonymous', function (newVal, oldVal) {
        if (newVal) {
            vm.donorAliasNameBak = vm.donation.donorAliasName;
            vm.donation.donorAliasName = '';
            vm.donorNamePlaceHolder = "(anonymous)";
            vm.donorNameDisabled = true;
        }
        else {
            vm.donorNameDisabled = false;
            vm.donorNamePlaceHolder = "Your name (optional)";
            vm.donation.donorAliasName = vm.donorAliasNameBak;
        }
    });

    vm.hasUpliftedAmount = function () {
        return vm.hasFundings() || vm.hasGiftAid();
    };

    vm.hasGiftAid = function () {
        return vm.donation.giftAid && (vm.donation.donorType === 0);
    };

    vm.hasFundings = function () {
        return vm.fundingList.length > 0;
    };

    vm.login = function () {
        vm.clearP1Errors();

        PortalAPI.oneHitLogin(vm.loginDetails.email, vm.loginDetails.password).then(function (resp) {
            if (resp.error) {
                vm.loginDetails.loginError = resp.error;
            } else {
                vm.loginDetails.loggedIn = true;
                vm.loginDetails.name = getFullName(resp.token.first_name, resp.token.last_name);
            }
        });
    };

    vm.register = function () {
        vm.clearP1Errors();

        var gdprAnswers = [];
		for (var property in vm.registerDetails.answers) {
			if (vm.registerDetails.answers.hasOwnProperty(property)) {
				gdprAnswers.push({
					QuestionId: property,
					Answer: vm.registerDetails.answers[property]
				});
			}
		}

		vm.gRecaptcha.execute({action: 'selfRegistration_donorJourney'})
			.then(function (token) {
				// returns token from Google Recaptcha

                PortalAPI.oneHitRegister(vm.registerDetails.email, vm.registerDetails.firstName, vm.registerDetails.lastName, vm.registerDetails.password, gdprAnswers, token)
                    .then(function (resp) {
                        if (resp.error)
                        {
                            vm.registerDetails.registerError = resp.error;
                        } else {
                            vm.loginDetails.loggedIn = true;
                            vm.loginDetails.name = getFullName(vm.registerDetails.firstName, vm.registerDetails.lastName);
                            vm.loginDetails.email = vm.registerDetails.email;
                            vm.loginDetails.newUser = true;

                            vm.setDisplayRegister(false);
                        }
                    });
                });
            };

    vm.forgotPassword.getEmailControl = function () {
        var validEmailControls = vm.donationForm.$$success.email;
        var emailControl = validEmailControls.find(a => a.$name === 'forgotPasswordEmail');

        return emailControl;
    };

    vm.forgotPassword.checkValidEmail = function (ctrl) {
        var emailControl = ctrl ? ctrl : vm.forgotPassword.getEmailControl();

        return emailControl && emailControl.$modelValue;
    };

    vm.forgotPasswordToggle = function () {
        vm.forgotPassword.display = !vm.forgotPassword.display;
        vm.forgotPassword.success = false;
        vm.forgotPassword.error = null;
        vm.forgotPassword.email = '';
    };

    vm.forgotPasswordClick = function () {
        vm.clearP1Errors();

        var emailControl = vm.forgotPassword.getEmailControl();
        if (!vm.forgotPassword.checkValidEmail(emailControl)) {
            vm.forgotPassword.error = "Please enter a valid email address and try again";
        }
        else {
            PortalAPI
                .forgotPassword({
                    email: emailControl.$modelValue
                })
                .then(function (resp) {
                    vm.forgotPassword.error = null;
                    vm.forgotPassword.success = true;
                }, function (resp) {
                    vm.forgotPassword.error = resp.body ? (resp.body.message) : null;
                    if (!vm.forgotPassword.error) {
                        vm.forgotPassword.error = "Unknown Error";
                    }
                    vm.forgotPassword.success = null;
                }
                );
        }
    }

    vm.clearP1Errors = function (){
        vm.forgotPassword.error = null;
        vm.forgotPassword.success = null;
        delete vm.loginDetails.loginError;

        vm.registerDetails.registerError = null;
    }

    vm.addressName = function () {
        return vm.donation.donorType === 1 ? "Company" 
                : vm.donation.donorType === 3 ? "Organisation" 
                : "Home";
    };

    vm.checkPageOneValid = function () {
        return vm.loginDetails.loggedIn && 
                (vm.donation.donationAmount > 0) &&
                $scope.donationForm.$valid
                ;
    };

    vm.paymentDetailsValid = function () {
        return (vm.donation.paymentTypeBacs
                    ? true
                    : vm.paymentcard.name && vm.paymentcard.number && vm.paymentcard.expiryMonth && vm.paymentcard.expiryYear && vm.paymentcard.cvv)
                && vm.billing.address1 && vm.billing.postcode
                && (!vm.donor.isDonorAddressDifferent || (vm.donor.address1 && vm.donor.postcode));
    };

    var orderId;
    var thankUserForTheirPayment = function () {
        updateFundingList(true);
        vm.setPage(4);
    };
    var tellUserTheirPaymentWasDeclined = function () {
        displayErrorPage('Sorry, we could not complete your donation');
    };

    var tellUserThereWasAnUnexpectedProblem = function (err, shortGuid) {
        displayErrorPage('We are sorry, but we could not process your donation.  Please try again later or contact your card provider');
    };

    var displayErrorPage = function(message){
        vm.errorMessage = message;
        vm.setPage(4);
    }

    vm.setNextAction = function (theNextAction) {
        vm.postDonation.nextAction = theNextAction;
    };

    vm.registerDonation = function () {
        vm.BACS_attempted = true;
        vm.clearP1Errors();
        vm.preDonationCleaning();

        var addressDetails = vm.getAddressDetails();

        var registration = {
            applicationId: vm.application.id,
            address: addressDetails.address,
            companyBenefits: vm.donation.companyBenefits,
            companyName: vm.donation.companyName,
            donationAmount: vm.donation.donationAmount,
            donorMessage: vm.donation.donorMessage,
            donorName: vm.donation.donorName,
            donorType: vm.donation.donorType,
            email: vm.donation.email,
            fundraiserId: vm.fundraiserId,
            giftAid: vm.donation.giftAid,
            giftAidAddress: addressDetails.donorAddress,
            giftAidConfirm: vm.donation.giftAidConfirm,
            giftAidPostcode: addressDetails.donorPostcode,
            isAnonymous: vm.donation.isAnonymous,
            isCompanyBenefit: vm.donation.isCompanyBenefit,
            nameAlias: vm.donation.donorAliasName,
            postcode: addressDetails.postcode,
            termsAndConditions: vm.donation.termsAndConditions,
        };

        DonationAPI
            .registerBacsDonation(registration)
            .then(function (resp) {
                if (resp)
                {
                    vm.donationId = resp.donationId;
                    if (vm.donationId) {
                        vm.BACS_registered = true;
                        updateFundingList(true);
                        vm.setPage(4);
                    }
                }
                if (!vm.BACS_registered){
                    tellUserThereWasABacsError();
                }
            }, function (err) {
                var message;
                if (err && err.body) {
                    message = err.body.message;
                }
                tellUserThereWasABacsError(message);
            })
            .catch(function(err){
                tellUserThereWasABacsError();
            });
    };

    function tellUserThereWasABacsError(message){
        if (!message){
            message = "Sorry, there was an error registering your pledge.  Please try again later.";
        }
        displayErrorPage(message);
    }


    vm.getAddressDetails = function (){
        var details = {};
        var mainAddress = vm.donation.paymentTypeBacs 
                            ? vm.donor : vm.billing;

        details.address = _.compact([mainAddress.address1, mainAddress.address2, mainAddress.townCity, mainAddress.county]).join(', ');
        details.postcode = mainAddress.postcode;
        if (!vm.donor.paymentTypeBacs && vm.donor.isDonorAddressDifferent) {
            details.donorAddress = _.compact([vm.donor.address1, vm.donor.address2, vm.donor.townCity, vm.donor.county]).join(', ');
            details.donorPostcode = vm.donor.postcode;
        }
        else {
            details.donorAddress = details.address;
            details.donorPostcode = details.postcode;
        }
        
        return details;
    };

    vm.preDonationCleaning = function(){
        // If no donorAliasName, make it anonymous
        if (!vm.donation.isAnonymous && !vm.donation.donorAliasName) {
            vm.donation.isAnonymous = true;
        }
        
        vm.donation.donorName = getDonorName();

        // If not company, clear company fields
        if (vm.donation.donorType != 1)
        {
            vm.donation.isCompanyBenefit = false;
            vm.donation.companyBenefits = null;
            vm.donation.companyName = vm.donation.charityName;
        }

        // If not personal, ensure giftAid not checked
        if (vm.donation.donorType != 0)
        {
            vm.donation.giftAid = false;
            vm.donation.giftAidConfirm = false;
        }
    };
    
    vm.donateNow = function () {
        vm.paymentAttempted = true;
        vm.preDonationCleaning();

        var addressDetails = vm.getAddressDetails();
 
        vm.paymentInProgress = true;
        vm.paymentStatusMessage = "Making donation...";
        var browserInfo = vm.getBrowserInfo();

        PaymentGatewayApi.ProcessPayment(
            vm.application.id,
            vm.paymentcard,
            vm.donation,
            addressDetails.address,
            addressDetails.postcode,
            addressDetails.addressDonor,
            addressDetails.postcodeDonor,
            vm.fundraiserId,
            browserInfo
            )
            .then(function (params) {
                vm.paymentInProgress = false;
                if (params.htmlAnswer) {
                    orderId = params.orderId;
                    vm.paymentStatusMessage = "Your card issuer needs to validate your payment";
                    vm.threeDSecureContent = params.htmlAnswer;
                } else if (params.status === "PaymentRequested") {
                    vm.donationId = params.donationId;
                    thankUserForTheirPayment();
                } else if (params.status === "Refused") {
                    tellUserTheirPaymentWasDeclined();
                } else {
                    tellUserThereWasAnUnexpectedProblem();
                }
            })
            .error(function (e) {
                console.error('Process Payment returned error. ' + e);
                tellUserThereWasAnUnexpectedProblem();
            })
            .catch(function (e) {
                if ((e.err.statusCode == 422) && (e.err.body && e.err.body.message)) {
                    displayErrorPage(e.err.body.message);
                }
                else {
                    console.error('Process Payment threw exception. ' + e);
                    tellUserThereWasAnUnexpectedProblem();
                }
            });

        return;
    };

    vm.getBrowserInfo = function () {
        return {
            browserColorDepth: screen.colorDepth,
            browserJavaEnabled: navigator.javaEnabled(),
            browserLanguage: navigator.language,
            browserScreenHeight: screen.height,
            browserScreenWidth: screen.width,
            browserTimeZone: new Date().getTimezoneOffset(),
            browserUserAgent: navigator.userAgent
        }
    }

    vm.threeDSecureCallback = function (href) {
        if (href) {
            vm.paymentInProgress = true;
            vm.paymentStatusMessage = "Completing payment...";
            vm.threeDSecureContent = "";
            PaymentGatewayApi.Validate3dSecureResult(href, orderId).then(function (result) {
                vm.donationId = result.response;
                if (result.result === "accept") {
                    thankUserForTheirPayment();
                } else if (result.result === "decline") {
                    tellUserTheirPaymentWasDeclined();
                }
            });
        }
    };

    // True if: partial allowed and haven't identified card type yet
    //      or: cardType is not on invalidList
    // $ccType is the type of card if it matches completely
    // $ccEeagerType is the type of card if the number is could be the beginning of a valid no.
    vm.checkCardType = function (complete) {
        var cardType = vm.donationForm.cardNumber
            ? (complete ? vm.donationForm.cardNumber.$ccType 
                        : vm.donationForm.cardNumber.$ccEagerType)
            : null;
//        var validCards = ["Visa", "MasterCard"];
        var inValidCards = ["American Express", "Diners Club"];
        return (!complete && !cardType) 
                || (!inValidCards.includes(cardType) && cardType);
    };

    vm.checkLoginDetails = function () {
        var email = vm.donationForm.loginEmail;
        var emailValid = email && !email.$invalid;
        var password = vm.donationForm.loginPassword;
        var passwordValid = password && !password.$invalid;

        return !vm.loginDetails.loggedIn && !vm.forgotPassword.display && emailValid && passwordValid;
    };

    vm.checkRegisterDetails = function () {
        var email = vm.donationForm.registerEmail;
        var emailValid = email && !email.$invalid;
        var firstName = vm.donationForm.registerFirstName;
        var firstNameValid = firstName && !firstName.$invalid;
        var lastName = vm.donationForm.registerLastName;
        var lastNameValid = lastName && !lastName.$invalid;
        var password = vm.donationForm.registerPassword;
        var passwordValid = password && !password.$invalid;
        var termsAndConditionsAccepted = vm.registerDetails.termsAndConditions;
                
        return emailValid && firstNameValid && lastNameValid && passwordValid && termsAndConditionsAccepted;
    };

    vm.getPopupTextMessage = function () {
        return 'Donor comments will appear at the bottom of each project page e.g. ' + window.location.href;
    };

    vm.getPopupHtmlFunder = function (funding) {
        return `Funders can offer match funding on donations. ${funding.funderName} has matched your donation on a `
        + `${funding.ratioDonate}:${funding.ratioMatch} ratio (maximum of £${funding.maxDonation} available).  `
        + 'Learn more about <a href="https://thegoodexchange.com/who-we-are/help-support/#match-funding" target="_blank">Match Funding</a>.';
    };

    vm.shareDetails = function(){
        setTimeout(function(){
            DonationAPI.UpdateShareDetails(
                vm.donationId,
                vm.postDonation.shareDetails
            );
        });
    }

    vm.init = function () {
		var recaptchaPublicKey = window.conf.recaptcha_public_key;
		vm.gRecaptcha.initialize({key: recaptchaPublicKey});

        vm.loading = true;
        ApplicationsAPI.GetFromUserRef(
            $scope.ngDialogData.applicationId,
            "ApplicationDonationView"
        ).then(function (result) {
            vm.application = result;
            updateFundingList(false);
        });

        UserAPI.GetQuestions()
			.then(function(questions) {
				vm.questions = questions;
			})
			.catch(function() {
			});
    };

    function roundToPence(a){
        return Math.round(a * 100) / 100;
    }

    vm.init();
}
